import script from "./JourneySearchRow.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneySearchRow.vue?vue&type=script&setup=true&lang=js"

import "./JourneySearchRow.vue?vue&type=style&index=0&id=80215956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80215956"]])

export default __exports__